import * as angular from "angular";

let AdminMainDetails = {
    selector: "vcAdminMainDetails",
    templateUrl:
        "/angular/components/admin/dialogs/sections/admin-main-details.component.html",
    bindings: {
        limits: "=",
        model: "=",
    },
    controller: class AdminMainDetailsController {
        // * bindings for typescript compiler *
        public limits: any;
        public model: any;
        // ************************************
    },
};

angular.module("admin").component(AdminMainDetails.selector, AdminMainDetails);
